<an-base-modal (onCloseModal)="closeModal()">
  <div class="an-price-details-modal">
    <ng-container *ngIf="items.length > 0; else jackedup">
      <div class="an-price-details-modal__content">
        <div class="an-price-details-modal__title"> {{ title }} </div>

        <ng-template #tplPriceItem let-item="item">
          <div class="an-price-item__name">
            <span> {{ item.Name }} </span>
            <span class="an-price-item__tooltip" *ngIf="item.tooltipText" (click)="openTooltip(item)"></span>
          </div>
          <div class="an-price-item__wrap">
            <div class="an-price-item__sign">
              {{ item.sign }}
            </div>
            <div class="an-price-item__value" [ngStyle]="{'font-weight': item.bold ? 'bold' : 'normal'}">
              ${{ item.Value | number: '1.0-0' }}
            </div>
          </div>
        </ng-template>
        
        <div class="an-price-details-modal__price-item" *ngFor="let item of topItems; let last = last"
          [ngClass]="{'an-last-item': last}">
          <ng-container *ngTemplateOutlet="tplPriceItem; context: { item: item }"></ng-container>
        </div>

        <div class="an-price-details-modal__price-item" *ngFor="let item of contentItems; let first = first"
          [ngClass]="{'an-first-item': first}">
          <ng-container *ngTemplateOutlet="tplPriceItem; context: { item: item }"></ng-container>
        </div>
      </div>

      <div class="an-price-details-modal__footer">
        <div class="an-balance-due">
          <span class="an-balance-due__name"> {{ balanceDue?.Name }} </span>
          <span class="an-balance-due__estimated"> ({{ estimated }}) </span>
        </div>
        <div class="an-balance-due__value">
          ${{ balanceDue?.Value | number: '1.0-0' }}
        </div>
      </div>
    </ng-container>

    <ng-template #jackedup>
      <div class="an-price-details-modal__jackedup">
        <div class="jackedup__container">
          <div class="an-jackedup__image"></div>
          <div class="an-jackedup__title"> {{ jackedupTitle }} </div>
          <div class="an-jackedup__subtitle"> {{ jackedupSubtitle }} </div>
          <div class="an-jackedup__button-wrap">
            <button class="an-jackedup__cta" (click)="closeModal()"> {{ tryAgain }} </button>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</an-base-modal>